import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import THEME from '../../styles/colors';
import Icon from '../../ui/Icon/Icon';

const StyledSearchForm = styled.form`
  background: ${THEME.surface.secondary};
  color: ${THEME.text.secondary};
  border-radius: 12px;
  width: 100%;
  height: 46px;
  position: relative;
`;

const StyledSearchInput = styled.input`
  height: 100%;
  width: 100%;
  background: none;
  outline: none;
  padding: 0 58px 0 16px;
`;

const StyledSearchButton = styled.button`
  background-color: transparent;
  border: none;
  height: 48px;
  padding: 0 16px;
  cursor: pointer;

  position: absolute;
  right: 0;
  height: 100%;
`;

interface IHamburgerSearchProps {
  isSearchFocused: boolean;
}

const HamburgerSearch: React.FC<IHamburgerSearchProps> = ({
  isSearchFocused
}) => {
  const ref = useRef<any>();

  useEffect(() => {
    if (isSearchFocused) ref.current.focus();
  }, [isSearchFocused]);

  return (
    <StyledSearchForm
      action="https://www.maxpreps.com/search/default.aspx"
      // @ts-ignore
      autocomplete="off"
    >
      <StyledSearchInput
        placeholder="Search Schools & Athletes"
        ref={ref}
        type="search"
        name="search"
      />
      <StyledSearchButton type="submit">
        <Icon icon={faSearch} size={20} color={THEME.other.icon} />
      </StyledSearchButton>
    </StyledSearchForm>
  );
};

export default HamburgerSearch;
